import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from 'react-i18next';
import { ChordNode } from "./ChordChart";
import ISONumber from "components/formatting/ISONumber";

interface ChordChartNodeTooltipProps {
  node: ChordNode;
  nodeColor: string;
}

// Tooltip content component
export default function ChordChartNodeTooltip(props: ChordChartNodeTooltipProps): JSX.Element {
  const { i18n } = useTranslation();

  return (
    <Box>
      <Typography sx={{mb: 1, color: props.nodeColor}} variant="h4">
        {props.node._label}
      </Typography>
      <Typography>
        {i18n.t("record-count")}:
        <Box sx={{display:"inline-block", ml: 1, fontWeight:"bold"}}>
          <ISONumber number={props.node._count} />
        </Box>
      </Typography>
    </Box>
  );
};
